module.exports = __webpack_public_path__ + "static/media/i-dont-work-you-dig.4d1d78dc.txt";